import React from 'react'

import HeaderCell from '../../../../preview/HeaderCell'
import HeaderFormat from '../../../../preview/HeaderFormat'
import Cell from '../../../../preview/Cell'
import CellSettings from '../../../../preview/CellSettings'
import { EventBatch, SpreadsheetHeader } from '../types'

interface Props {
    header: SpreadsheetHeader[]
    headerConfig: SpreadsheetHeader[]
    setHeader: (header: SpreadsheetHeader[]) => void
    data: EventBatch[]
    onlyView: boolean
    update: (key: string, value: any) => void
}

function Table({ header = [], headerConfig, data = [], onlyView, setHeader }: Props) {
    return (
        <div className="sheet-preview" style={{            
            height:'500px'
        }} >
            <div className="sheet-stage">
                <div className="shadow">
                    <table className="sheet">
                        <thead>
                            <tr>
                                <th className="no-border"></th>
                                {header.map((cell, cellId) => {
                                    const updateCell = (newHeader: SpreadsheetHeader) => {
                                        const newHeaders = header.map((currHeader, index) =>
                                            index === cellId ? newHeader : currHeader
                                        )
                                        
                                        setHeader(newHeaders)
                                    }
                                    return (
                                        <HeaderCell
                                            sheet={0}
                                            key={cellId}
                                            onlyView={onlyView}
                                            updateCell={updateCell}
                                            cell={cell}
                                        />
                                    )
                                })}

                                {headerConfig.map((cell, cellId) => {
                                    const updateCell = (newHeader: SpreadsheetHeader) => {
                                        const newHeaders = header.map((currHeader, index) =>
                                            index === cellId ? newHeader : currHeader
                                        )
                                        setHeader(newHeaders)
                                    }
                                    return (
                                        <HeaderCell
                                            sheet={0}
                                            key={cellId}
                                            onlyView={true}
                                            updateCell={updateCell}
                                            cell={cell}
                                        />
                                    )
                                })}
                            </tr>
                            <tr>
                                <th />
                                {header.map((cell, cellId) => {
                                    const updateCell = (newHeader: SpreadsheetHeader) => {
                                        const newHeaders = header.map((currHeader, index) =>
                                            index === cellId ? newHeader : currHeader
                                        )
                                        setHeader(newHeaders)
                                    }
                                    return (
                                        <HeaderFormat
                                            sheet={0}
                                            cell={cell}
                                            updateCell={updateCell}
                                            key={cellId}
                                            // update={update}
                                            onlyView={onlyView}
                                            outsideClickIgnoreClass="rc-menu-item"
                                        />
                                    )
                                })}
                                {headerConfig.map(() => (
                                    <th style={{ backgroundColor: 'var(--gray-100)' }} />
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((event, index) => {
                                return (
                                    <tr key={`event-${index}`}>
                                        <td>{index + 1}</td>
                                        {header.map((header, col) => {
                                            return (
                                                <Cell
                                                    key={`event-${index}-${col + 1}`}
                                                    value={event[header?.alias]}
                                                    isDisabled={header.isDisabled}
                                                />
                                            )
                                        })}
                                        {headerConfig.map((key, column) => {
                                            return (
                                                <CellSettings
                                                    value={String(event[key.alias] || '')}
                                                    field={key?.name}
                                                    key={`${key}-${index}-${column}`}
                                                />
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export { Table }
